// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-656db325]{background-color:var(--quiz-button-color);color:var(--quiz-button-text-color);border:0;border-radius:0;padding:15px 20px;font-size:14px;font-weight:700;text-transform:uppercase;letter-spacing:1.1px;cursor:pointer;transition:all .15s linear}button[data-v-656db325]:hover{background-color:var(--quiz-button-hover-color);color:var(--quiz-button-hover-text-color)}button[data-v-656db325]:disabled{cursor:not-allowed}", ""]);
// Exports
module.exports = exports;
